(() => {
  const copy = document.getElementById('copy-booking-link');
  const input = document.getElementById('booking-save-url');
  const status = document.getElementById('booking-copy-status');
  if (!copy || !input || !status) return;
  copy.hidden = false;
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(input.value);
      status.textContent = 'Booking link copied.';
    } catch {
      input.focus();
      input.select();
      status.textContent = 'Select and copy the booking link above.';
    }
  });
})();
